// DICOM versions object
// (only those published with this repo since NEMA does not do CORS...)
const dicomVersions = {
  2022: ['a'],
  2024: ['a'],
  2026: ['a'],
};

// Supported DICOM parts
const dicomParts = ['03', '05', '06', '07'];

/**
 * Get the list of DICOM standard parts.
 *
 * @returns {Array} An array of parts.
 */
export function getDicomParts() {
  return dicomParts;
}

/**
 * Get the list of DICOM standard versions.
 *
 * @returns {Array} An array of versions, ordered from most recent to older.
 */
export function getDicomVersions() {
  const keys = Object.keys(dicomVersions);
  keys.sort(compare);
  // create version strings
  const versions = [];
  for (const majorVersion of keys) {
    const minorVersions = dicomVersions[majorVersion];
    for (const minorVersion of minorVersions) {
      versions.push(majorVersion + minorVersion);
    }
  }
  // return
  return versions;
}

/**
 * Sort keys.
 *
 * @param {string} a First string.
 * @param {string} b Second string.
 * @returns {number} Negative is a > b.
 */
function compare(a, b) {
  return parseInt(b, 10) - parseInt(a, 10);
}

/**
 * Get a list of DICOM versions associated to their resrouce link.
 *
 * @param {string} partNumber The part number as a string.
 * @param {string} [basePath] Optional base path of the xml files,
 *   defaults to the github repository.
 * @returns {Array} An array of {xml, html} objects.
 */
export function getDicomPartLinks(partNumber, basePath) {
  const versions = getDicomVersions();
  const links = {};
  for (const version of versions) {
    links[version] = {
      xml: getXmlLink(version, partNumber, basePath),
      html: getHtmlLink(version, partNumber),
    };
  }
  // return
  return links;
}

/**
 * Get the xml link to the standard.
 * Links go to github by default since nema does not publish standard
 * with CORS.
 *
 * @param {string} version The standard version.
 * @param {string} partNumber The standard part number as a string.
 * @param {string} [basePath] Optional base path of the xml files,
 *   defaults to the github repository.
 * @returns {string} The full link to the desired file.
 */
function getXmlLink(version, partNumber, basePath) {
  if (typeof basePath === 'undefined') {
    basePath = 'https://raw.githubusercontent.com/ivmartel/dcmStdToJs/main/resources/standard';
  }
  const partFileName = 'part' + partNumber;
  return basePath + '/' + version + '/' + partFileName + '.xml';
}

/**
 * Get the html link to the standard.
 *
 * @param {string} version The standard version.
 * @param {string} partNumber The standard part number as a string.
 * @returns {string} The full link to the desired html.
 */
function getHtmlLink(version, partNumber) {
  const nemaRoot = 'http://dicom.nema.org/medical/dicom';
  const partFileName = 'part' + partNumber;
  return nemaRoot + '/' + version + '/output/html/' + partFileName + '.html';
}
